import serve from '@/utils/request.js'
import Setting from '@/settings.js'
var { apiDomain, interFaceDomain, dicDomain } = Setting
interFaceDomain = "https://www.fastmock.site/mock/9f5b07a35e6126897a07aba04649dfec/front"
export function getAllMediaList () {
  return serve.get(apiDomain + "/adminUser/selectAdminUserList", { pageNo: 1, pageSize: 10000 })
}
// 获取所有商务业务员
export function getAllShangwu () {
  return serve.get(interFaceDomain + "/jdmob/adminUser/selectBusinessAdminUserList", {})
}
//获取流量主列表
export function siteList (data) {
  return serve.post(apiDomain + "/siter/list", data)
}
//商务管理
// 广告主列表获取所有广告主
export function adverList (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/listAdUser", data)
}
// 重置密码
export function changePwd (param) {
  return serve.get(interFaceDomain + "/jdmob/user/resetPwd", param)
}
// 修改广告主启禁用状态
export function adverStatus (param) {
  return serve.get(interFaceDomain + "/jdmob/adUser/updateStatus", param)
}
// 创建广告主
export function createAdver (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/createUser", data)
}
// 编辑广告主
export function editAdver (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/updateUser", data)
}
// 广告主详情 adverDetail
export function adverDetail (param) {
  return serve.get(interFaceDomain + "/jdmob/adUser/detailUser", param)
}
// 验证邮箱唯一性
export function validateEmail (param) {
  return serve.get(interFaceDomain + "/jdmob/user/checkEmail", param)
}
//公司名称唯一性校验
export function validateCompany (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/checkAdUserOnlyOne", data)
}
// 获取广告主的产品列表
export function advertiserProduct (param) {
  return serve.get(interFaceDomain + "/jdmob/adUser/getProductListByUserId", param)
}
//数据包产品筛选产品列表
export function packetProduct (param) {
  return serve.get(interFaceDomain + "/jdmob/adUser/packageManager/listProductByUserId", param)
}
// 数据包列表
export function packetList (data) {
  return serve.post(interFaceDomain + "/jdmob/datapackage/list", data)
}
// 修改数据包状态
export function packetStatus (data) {
  return serve.post(interFaceDomain + "/jdmob/datapackage/editStatus", data)
}
// 数据包管理-数据包详情
export function packetDetail (param) {
  return serve.get(interFaceDomain + "/jdmob/datapackage/info", param)
}

//数据包管理-广告主区间列表
export function adSection (data) {
  return serve.post(interFaceDomain + "/jdmob/adInterval/arealist", data)
}
//获取所有产品
export function allProduct (data) {
  return serve.post(interFaceDomain + "/jdmob/product/list", data)
}
// 创建数据包
export function createPacket (data) {
  return serve.post(interFaceDomain + "/jdmob/datapackage/create", data)
}
//修改数据包
export function editPacket (data) {
  return serve.post(interFaceDomain + "/jdmob/datapackage/edit", data)
}
//获取已录入预估数据的日期
export function dateList (param) {
  return serve.get(interFaceDomain + "/date", param)
}
//预估数据录入获取数据包信息
export function packetInfo (param) {
  return serve.get(interFaceDomain + "/getPacketInfo", param)
}
//获取财务人员列表
export function getAllFinance (param) {
  return serve.get(interFaceDomain + "/jdmob/adminUser/selectFinanceAdminUserList", param)
}

//获取媒介人员列表
export function getAllMedia (param) {
  return serve.get(interFaceDomain + "/jdmob/adminUser/selectMediaAdminUserList", param)
}
//获取产品列表和广告主名称列表
export function getProductAduser () {
  return serve.all([
    serve.post(interFaceDomain + '/jdmob/product/list', { pageNo: 1, pageSize: 10000 }),
    serve.post(interFaceDomain + "/jdmob/adUser/listAdUser", {
      pageNo: 1,
      pageSize: 100000
    })
  ])
}
// 数据包查看详情预估数据列表
export function packetEstimate (data) {
  return serve.post(interFaceDomain + "/jdmob/estimate/listByAdPackageId", data)
}
export function packetNum (data) {
  return serve.post(interFaceDomain + "/jdmob/datapackage/dataPackageAssignLauchStatusSum", data)
}
//3.3获取广告主区间核准详情列表
export function getAdAreaList (param) {
  return serve.get(interFaceDomain + "/jdmob/adInterval/listIntervalPriceById", param)
}
// 3.3.4  提醒功能

export function remind (param) {
  return serve.get(interFaceDomain + "/jdmob/remind/allRemaind", param)
}
//创建广告主
export function addBasicInfo (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/createUser", data)
}
// 创建主体和收件信息
export function addAdver (param1, param2) {
  return serve.all([
    serve.post(interFaceDomain + "/jdmob/adUser/subject/create", param1),
    serve.post(interFaceDomain + "/jdmob/adUser/receiveInfo/create", param2)
  ])
}
// 编辑基本信息
export function editBasicInfo (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/updateUser", data)
}
// 更新基本信息
export function updateBasicInfo (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/updateUser", data)
}
// 新增主体信息
export function addSubjectInfo (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/subject/create", data)
}
// 更新主体信息
export function updateSubjectInfo (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/subject/update", data)
}
// 新增收件信息
export function addReceiveInfo (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/receiveInfo/create", data)
}
// 更新收件信息
export function updateReceiveInfo (data) {
  return serve.post(interFaceDomain + "/jdmob/adUser/receiveInfo/update", data)
}

// 信息查询
export function searchInfo (param1, param2, param3) {
  return serve.all([
    serve.get(interFaceDomain + "/jdmob/adUser/detailUser", param1),
    serve.get(interFaceDomain + "/jdmob/adUser/subject/list", param2),
    serve.get(interFaceDomain + "/jdmob/adUser/receiveInfo/list", param3)
  ])
}
//获取主体列表
export function getSubjectList (param) {
  return serve.get(interFaceDomain + "/jdmob/adUser/subject/list", param)
}
// 获取收件信息列表
export function getReceiveList (param) {
  return serve.get(interFaceDomain + "/jdmob/adUser/receiveInfo/list", param)
}
// 广告主名称唯一性校验
export function checkAdName (data) {
  return serve.post(interFaceDomain + "/jdmob/user/checkName", data)
}

// 主体名称唯一性校验
export function checkSubjectName (data) {
  return serve.post(interFaceDomain + "/jdmob/subject/checkName", data)
}